import { create } from 'zustand';

/** Пропуск Chatwoot (devise-token-auth): набор заголовков, а не один токен. */
export interface ChatwootHeaders {
  'access-token': string;
  client: string;
  uid: string;
  expiry?: string;
  'token-type'?: string;
}

export interface ChatwootUser {
  id: number;
  email: string;
  name: string;
}

interface ChatwootState {
  headers: ChatwootHeaders | null;
  user: ChatwootUser | null;
  /** Только в памяти: после перезапуска обмениваем пропуск UNIA заново. */
  setSession: (headers: ChatwootHeaders, user: ChatwootUser | null) => void;
  setHeaders: (headers: ChatwootHeaders) => void;
  clear: () => void;
}

export const useChatwootStore = create<ChatwootState>((set) => ({
  headers: null,
  user: null,
  setSession: (headers, user) => set({ headers, user }),
  setHeaders: (headers) => set({ headers }),
  clear: () => set({ headers: null, user: null }),
}));
